export const getBanners = (state) => state.banners.banners;